/* REG Furniture — progressive enhancement for the editorial slideshow.
   Product options, pricing, media and cart behavior remain owned by Hyper. */
if (!customElements.get('reg-slideshow')) {
  customElements.define('reg-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.buttons = [...this.querySelectorAll('[data-slide-index]')];
      this.current = 0;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const controls = this.querySelector('[data-controls]');
      if (controls && this.slides.length > 1) controls.hidden = false;
      this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.current - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1), options);
      this.buttons.forEach(button => button.addEventListener('click', () => this.show(Number(button.dataset.slideIndex)), options));
      controls?.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.show(this.current + (event.key === 'ArrowRight' ? 1 : -1));
        this.buttons[this.current]?.focus();
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
        if (index >= 0) this.show(index, false);
      }, options);
      // No automatic rotation: the reader controls the pace, including on mobile.
    }
    disconnectedCallback() { this.events?.abort(); }
    show(index, announce = true) {
      if (!this.slides.length) return;
      this.current = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.current; });
      this.buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === this.current)));
      const status = this.querySelector('[data-slide-status]');
      if (status && announce) status.textContent = `Slide ${this.current + 1} of ${this.slides.length}`;
    }
  });
}
